/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

export default {
    currency: 'GBP',
    id: 'winter-lookM',
    imageGroups: [
        {
            images: [
                {
                    alt: 'Winter Look, , large',
                    disBaseLink:
                        'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                    link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                    title: 'Winter Look, '
                }
            ],
            viewType: 'large'
        },
        {
            images: [
                {
                    alt: 'Winter Look, , medium',
                    disBaseLink:
                        'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                    link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                    title: 'Winter Look, '
                }
            ],
            viewType: 'medium'
        },
        {
            images: [
                {
                    alt: 'Winter Look, , small',
                    disBaseLink:
                        'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                    link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                    title: 'Winter Look, '
                }
            ],
            viewType: 'small'
        }
    ],
    longDescription: '<p>Jacket</p>\r\n<p>Pant</p>\r\n<p>Shoes</p>',
    minOrderQuantity: 1,
    name: 'Winter Look',
    price: 44.16,
    priceMax: 71.03,
    pricePerUnit: 44.16,
    pricePerUnitMax: 71.03,
    priceRanges: [
        {
            maxPrice: 101.76,
            minPrice: 44.16,
            pricebook: 'gbp-m-list-prices'
        },
        {
            maxPrice: 71.03,
            minPrice: 44.16,
            pricebook: 'gbp-m-sale-prices'
        }
    ],
    primaryCategoryId: 'womens-outfits',
    setProducts: [
        {
            currency: 'GBP',
            id: '25518447M',
            imageGroups: [
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, '
                        },
                        {
                            alt: 'Quilted Jacket, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb2158085/images/large/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb2158085/images/large/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, '
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, royal, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwe1c4cd52/images/large/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, royal'
                        },
                        {
                            alt: 'Quilted Jacket, royal, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb2158085/images/large/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwb2158085/images/large/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, royal'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ5FUXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, '
                        },
                        {
                            alt: 'Quilted Jacket, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw34fd2ab3/images/medium/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw34fd2ab3/images/medium/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, '
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, royal, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw07f25517/images/medium/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, royal'
                        },
                        {
                            alt: 'Quilted Jacket, royal, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw34fd2ab3/images/medium/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw34fd2ab3/images/medium/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, royal'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ5FUXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, '
                        },
                        {
                            alt: 'Quilted Jacket, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbb5eb9b1/images/small/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbb5eb9b1/images/small/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, '
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, royal, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwab300645/images/small/PG.10205921.JJ5FUXX.PZ.jpg',
                            title: 'Quilted Jacket, royal'
                        },
                        {
                            alt: 'Quilted Jacket, royal, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbb5eb9b1/images/small/PG.10205921.JJ5FUXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwbb5eb9b1/images/small/PG.10205921.JJ5FUXX.BZ.jpg',
                            title: 'Quilted Jacket, royal'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ5FUXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Quilted Jacket, royal, swatch',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5dea9b57/images/swatch/PG.10205921.JJ5FUXX.CP.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5dea9b57/images/swatch/PG.10205921.JJ5FUXX.CP.jpg',
                            title: 'Quilted Jacket, royal'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ5FUXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'swatch'
                }
            ],
            inventory: {
                ats: 365,
                backorderable: false,
                id: 'inventory_m',
                orderable: true,
                preorderable: false,
                stockLevel: 365
            },
            longDescription:
                'A classic quilted car coat looks new again.  Add a great Commerce Cloud Store top for a perfect look.',
            master: {
                masterId: '25518447M',
                orderable: true,
                price: 71.03
            },
            minOrderQuantity: 1,
            name: 'Quilted Jacket',
            pageDescription:
                'A classic quilted car coat looks new again.  Add a great Commerce Cloud Store top for a perfect look.',
            pageTitle: 'Quilted Jacket',
            price: 71.03,
            pricePerUnit: 71.03,
            priceRanges: [
                {
                    maxPrice: 101.76,
                    minPrice: 101.76,
                    pricebook: 'gbp-m-list-prices'
                },
                {
                    maxPrice: 71.03,
                    minPrice: 71.03,
                    pricebook: 'gbp-m-sale-prices'
                }
            ],
            primaryCategoryId: 'womens-clothing-jackets',
            productPromotions: [
                {
                    calloutMsg: '$10 off product set',
                    promotionId: '$10 off product set'
                }
            ],
            shortDescription:
                'A classic quilted car coat looks new again.  Add a great Commerce Cloud Store top for a perfect look.',
            stepQuantity: 1,
            type: {
                master: true
            },
            validFrom: {
                default: '2010-10-21T04:00:00.000Z'
            },
            variants: [
                {
                    orderable: true,
                    price: 71.03,
                    productId: '701642853695M',
                    tieredPrices: [
                        {
                            price: 101.76,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 71.03,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ5FUXX',
                        size: '9LG'
                    }
                },
                {
                    orderable: true,
                    price: 71.03,
                    productId: '701642853718M',
                    tieredPrices: [
                        {
                            price: 101.76,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 71.03,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ5FUXX',
                        size: '9SM'
                    }
                },
                {
                    orderable: true,
                    price: 71.03,
                    productId: '701642853725M',
                    tieredPrices: [
                        {
                            price: 101.76,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 71.03,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ5FUXX',
                        size: '9XL'
                    }
                },
                {
                    orderable: true,
                    price: 71.03,
                    productId: '701642853701M',
                    tieredPrices: [
                        {
                            price: 101.76,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 71.03,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ5FUXX',
                        size: '9MD'
                    }
                }
            ],
            variationAttributes: [
                {
                    id: 'color',
                    name: 'Colour',
                    values: [
                        {
                            name: 'royal',
                            orderable: true,
                            value: 'JJ5FUXX'
                        }
                    ]
                },
                {
                    id: 'size',
                    name: 'Size',
                    values: [
                        {
                            name: 'S',
                            orderable: true,
                            value: '9SM'
                        },
                        {
                            name: 'M',
                            orderable: true,
                            value: '9MD'
                        },
                        {
                            name: 'L',
                            orderable: true,
                            value: '9LG'
                        },
                        {
                            name: 'XL',
                            orderable: true,
                            value: '9XL'
                        }
                    ]
                }
            ],
            c_isNewtest: true,
            c_isSale: true
        },
        {
            currency: 'GBP',
            id: '25518704M',
            imageGroups: [
                {
                    images: [
                        {
                            alt: 'Pull On Pant, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw018b9798/images/large/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw018b9798/images/large/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, '
                        },
                        {
                            alt: 'Pull On Pant, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5303e0ee/images/large/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5303e0ee/images/large/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, '
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, Grey Heather, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw018b9798/images/large/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw018b9798/images/large/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        },
                        {
                            alt: 'Pull On Pant, Grey Heather, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5303e0ee/images/large/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5303e0ee/images/large/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ2XNXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwba195443/images/medium/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwba195443/images/medium/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, '
                        },
                        {
                            alt: 'Pull On Pant, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8119e7a0/images/medium/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8119e7a0/images/medium/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, '
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, Grey Heather, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwba195443/images/medium/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwba195443/images/medium/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        },
                        {
                            alt: 'Pull On Pant, Grey Heather, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8119e7a0/images/medium/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw8119e7a0/images/medium/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ2XNXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw19377146/images/small/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw19377146/images/small/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, '
                        },
                        {
                            alt: 'Pull On Pant, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw912e293d/images/small/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw912e293d/images/small/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, '
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, Grey Heather, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw19377146/images/small/PG.10218785.JJ2XNXX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw19377146/images/small/PG.10218785.JJ2XNXX.PZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        },
                        {
                            alt: 'Pull On Pant, Grey Heather, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw912e293d/images/small/PG.10218785.JJ2XNXX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw912e293d/images/small/PG.10218785.JJ2XNXX.BZ.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ2XNXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Pull On Pant, Grey Heather, swatch',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9dedffb4/images/swatch/PG.10218785.JJ2XNXX.CP.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9dedffb4/images/swatch/PG.10218785.JJ2XNXX.CP.jpg',
                            title: 'Pull On Pant, Grey Heather'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'JJ2XNXX'
                                }
                            ]
                        }
                    ],
                    viewType: 'swatch'
                }
            ],
            inventory: {
                ats: 480,
                backorderable: false,
                id: 'inventory_m',
                orderable: true,
                preorderable: false,
                stockLevel: 480
            },
            longDescription:
                'Meet a Commerce Cloud Store new wardrobe favorite - a knit pant that works perfectly 12 months a year!',
            master: {
                masterId: '25518704M',
                orderable: true,
                price: 44.16
            },
            minOrderQuantity: 1,
            name: 'Pull On Pant',
            pageDescription:
                'Meet a Commerce Cloud Store new wardrobe favorite - a knit pant that works perfectly 12 months a year!',
            pageTitle: 'Pull On Pant',
            price: 44.16,
            pricePerUnit: 44.16,
            priceRanges: [
                {
                    maxPrice: 44.16,
                    minPrice: 44.16,
                    pricebook: 'gbp-m-list-prices'
                },
                {
                    maxPrice: 44.16,
                    minPrice: 44.16,
                    pricebook: 'gbp-m-sale-prices'
                }
            ],
            primaryCategoryId: 'womens-clothing-bottoms',
            productPromotions: [
                {
                    calloutMsg: '$10 off product set',
                    promotionId: '$10 off product set'
                }
            ],
            shortDescription:
                'Meet a Commerce Cloud Store new wardrobe favorite - a knit pant that works perfectly 12 months a year!',
            stepQuantity: 1,
            type: {
                master: true
            },
            validFrom: {
                default: '2010-10-21T04:00:00.000Z'
            },
            variants: [
                {
                    orderable: true,
                    price: 44.16,
                    productId: '701642867098M',
                    tieredPrices: [
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ2XNXX',
                        size: '9LG'
                    }
                },
                {
                    orderable: true,
                    price: 44.16,
                    productId: '701642867111M',
                    tieredPrices: [
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ2XNXX',
                        size: '9SM'
                    }
                },
                {
                    orderable: true,
                    price: 44.16,
                    productId: '701642867104M',
                    tieredPrices: [
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ2XNXX',
                        size: '9MD'
                    }
                },
                {
                    orderable: true,
                    price: 44.16,
                    productId: '701642867128M',
                    tieredPrices: [
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ2XNXX',
                        size: '9XL'
                    }
                },
                {
                    orderable: true,
                    price: 44.16,
                    productId: '701642867135M',
                    tieredPrices: [
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 44.16,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'JJ2XNXX',
                        size: '9XS'
                    }
                }
            ],
            variationAttributes: [
                {
                    id: 'color',
                    name: 'Colour',
                    values: [
                        {
                            name: 'Grey Heather',
                            orderable: true,
                            value: 'JJ2XNXX'
                        }
                    ]
                },
                {
                    id: 'size',
                    name: 'Size',
                    values: [
                        {
                            name: 'XS',
                            orderable: true,
                            value: '9XS'
                        },
                        {
                            name: 'S',
                            orderable: true,
                            value: '9SM'
                        },
                        {
                            name: 'M',
                            orderable: true,
                            value: '9MD'
                        },
                        {
                            name: 'L',
                            orderable: true,
                            value: '9LG'
                        },
                        {
                            name: 'XL',
                            orderable: true,
                            value: '9XL'
                        }
                    ]
                }
            ],
            c_isNewtest: true
        },
        {
            currency: 'GBP',
            id: '25772717M',
            imageGroups: [
                {
                    images: [
                        {
                            alt: 'Zerrick, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw25b9c8eb/images/large/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw25b9c8eb/images/large/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, '
                        },
                        {
                            alt: 'Zerrick, , large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw42769ff1/images/large/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw42769ff1/images/large/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, '
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Black, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw25b9c8eb/images/large/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw25b9c8eb/images/large/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, Black'
                        },
                        {
                            alt: 'Zerrick, Black, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw42769ff1/images/large/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw42769ff1/images/large/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, Black'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'BLACKLE'
                                }
                            ]
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Taupe, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw08fba265/images/large/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw08fba265/images/large/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            title: 'Zerrick, Taupe'
                        },
                        {
                            alt: 'Zerrick, Taupe, large',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw20ceacbb/images/large/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw20ceacbb/images/large/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            title: 'Zerrick, Taupe'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'TAUPETX'
                                }
                            ]
                        }
                    ],
                    viewType: 'large'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ae06682/images/medium/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ae06682/images/medium/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, '
                        },
                        {
                            alt: 'Zerrick, , medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw025c3d0d/images/medium/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw025c3d0d/images/medium/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, '
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Black, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ae06682/images/medium/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0ae06682/images/medium/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, Black'
                        },
                        {
                            alt: 'Zerrick, Black, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw025c3d0d/images/medium/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw025c3d0d/images/medium/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, Black'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'BLACKLE'
                                }
                            ]
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Taupe, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0019f83a/images/medium/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw0019f83a/images/medium/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            title: 'Zerrick, Taupe'
                        },
                        {
                            alt: 'Zerrick, Taupe, medium',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2ac76531/images/medium/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw2ac76531/images/medium/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            title: 'Zerrick, Taupe'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'TAUPETX'
                                }
                            ]
                        }
                    ],
                    viewType: 'medium'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwfa0a6275/images/small/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwfa0a6275/images/small/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, '
                        },
                        {
                            alt: 'Zerrick, , small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw47a9b12f/images/small/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw47a9b12f/images/small/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, '
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Black, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwfa0a6275/images/small/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwfa0a6275/images/small/PG.CJZERRICK.BLACKLE.PZ.jpg',
                            title: 'Zerrick, Black'
                        },
                        {
                            alt: 'Zerrick, Black, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw47a9b12f/images/small/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw47a9b12f/images/small/PG.CJZERRICK.BLACKLE.BZ.jpg',
                            title: 'Zerrick, Black'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'BLACKLE'
                                }
                            ]
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Taupe, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwabc944c5/images/small/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwabc944c5/images/small/PG.CJZERRICK.TAUPETX.PZ.jpg',
                            title: 'Zerrick, Taupe'
                        },
                        {
                            alt: 'Zerrick, Taupe, small',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5b4e54ad/images/small/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw5b4e54ad/images/small/PG.CJZERRICK.TAUPETX.BZ.jpg',
                            title: 'Zerrick, Taupe'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'TAUPETX'
                                }
                            ]
                        }
                    ],
                    viewType: 'small'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Black, swatch',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcc030b86/images/swatch/PG.CJZERRICK.BLACKLE.CP.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dwcc030b86/images/swatch/PG.CJZERRICK.BLACKLE.CP.jpg',
                            title: 'Zerrick, Black'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'BLACKLE'
                                }
                            ]
                        }
                    ],
                    viewType: 'swatch'
                },
                {
                    images: [
                        {
                            alt: 'Zerrick, Taupe, swatch',
                            disBaseLink:
                                'https://edge.disstg.commercecloud.salesforce.com/dw/image/v2/ZZRF_001/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9dc4320e/images/swatch/PG.CJZERRICK.TAUPETX.CP.jpg',
                            link: 'https://zzrf-001.dx.commercecloud.salesforce.com/on/demandware.static/-/Sites-apparel-m-catalog/default/dw9dc4320e/images/swatch/PG.CJZERRICK.TAUPETX.CP.jpg',
                            title: 'Zerrick, Taupe'
                        }
                    ],
                    variationAttributes: [
                        {
                            id: 'color',
                            values: [
                                {
                                    value: 'TAUPETX'
                                }
                            ]
                        }
                    ],
                    viewType: 'swatch'
                }
            ],
            inventory: {
                ats: 1438,
                backorderable: false,
                id: 'inventory_m',
                orderable: true,
                preorderable: false,
                stockLevel: 1438
            },
            longDescription: 'The perfect pump for any outfit!',
            master: {
                masterId: '25772717M',
                orderable: true,
                price: 63.36
            },
            minOrderQuantity: 1,
            name: 'Zerrick',
            pageDescription: 'The perfect pump for any outfit!',
            pageTitle: 'Zerrick',
            price: 63.36,
            pricePerUnit: 63.36,
            priceRanges: [
                {
                    maxPrice: 63.36,
                    minPrice: 63.36,
                    pricebook: 'gbp-m-list-prices'
                },
                {
                    maxPrice: 63.36,
                    minPrice: 63.36,
                    pricebook: 'gbp-m-sale-prices'
                }
            ],
            primaryCategoryId: 'womens-accessories-shoes',
            productPromotions: [
                {
                    calloutMsg: '$10 off product set',
                    promotionId: '$10 off product set'
                }
            ],
            shortDescription: 'The perfect pump for any outfit!',
            stepQuantity: 1,
            type: {
                master: true
            },
            validFrom: {
                default: '2011-03-01T05:00:00.000Z'
            },
            variants: [
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357531M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '065',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358095M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '065',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357623M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '110',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357609M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '100',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358156M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '095',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358132M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '085',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358101M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '070',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357562M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '080',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357548M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '070',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358187M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '110',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357593M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '095',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357555M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '075',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357357524M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'BLACKLE',
                        size: '060',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358149M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '090',
                        width: 'M'
                    }
                },
                {
                    orderable: true,
                    price: 63.36,
                    productId: '740357358088M',
                    tieredPrices: [
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-list-prices',
                            quantity: 1
                        },
                        {
                            price: 63.36,
                            pricebook: 'gbp-m-sale-prices',
                            quantity: 1
                        }
                    ],
                    variationValues: {
                        color: 'TAUPETX',
                        size: '060',
                        width: 'M'
                    }
                }
            ],
            variationAttributes: [
                {
                    id: 'color',
                    name: 'Colour',
                    values: [
                        {
                            name: 'Black',
                            orderable: true,
                            value: 'BLACKLE'
                        },
                        {
                            name: 'Taupe',
                            orderable: true,
                            value: 'TAUPETX'
                        }
                    ]
                },
                {
                    id: 'size',
                    name: 'Size',
                    values: [
                        {
                            name: '6',
                            orderable: true,
                            value: '060'
                        },
                        {
                            name: '6.5',
                            orderable: true,
                            value: '065'
                        },
                        {
                            name: '7',
                            orderable: true,
                            value: '070'
                        },
                        {
                            name: '7.5',
                            orderable: true,
                            value: '075'
                        },
                        {
                            name: '8',
                            orderable: true,
                            value: '080'
                        },
                        {
                            name: '8.5',
                            orderable: true,
                            value: '085'
                        },
                        {
                            name: '9',
                            orderable: true,
                            value: '090'
                        },
                        {
                            name: '9.5',
                            orderable: true,
                            value: '095'
                        },
                        {
                            name: '10',
                            orderable: true,
                            value: '100'
                        },
                        {
                            name: '11',
                            orderable: true,
                            value: '110'
                        }
                    ]
                },
                {
                    id: 'width',
                    name: 'Width',
                    values: [
                        {
                            name: 'M',
                            orderable: true,
                            value: 'M'
                        }
                    ]
                }
            ]
        }
    ],
    shortDescription: 'Look for Winter',
    slugUrl:
        'https://zzrf-001.dx.commercecloud.salesforce.com/s/RefArchGlobal/womens/clothing/outfits/winter-lookM.html?lang=en_GB',
    stepQuantity: 1,
    type: {
        set: true
    }
}
